<div class="knowledge-hub-page">
  <app-header [forceLightBackground]="true"></app-header>

  <div class="knowledge-hub-page--content">
    <app-asset-header [config]="headerConfig"></app-asset-header>

    <div class="knowledge-hub-page--main">
      <div class="knowledge-hub-page--container">
        <div class="knowledge-hub-tabs" role="tablist" aria-label="Knowledge hub tabs">
          <button
            type="button"
            class="knowledge-hub-tabs--tab"
            role="tab"
            [attr.aria-selected]="activeTab === 'resources'"
            [class.active]="activeTab === 'resources'"
            (click)="setActiveTab('resources')"
          >
            Resources
          </button>
          <button
            type="button"
            class="knowledge-hub-tabs--tab"
            role="tab"
            [attr.aria-selected]="activeTab === 'stories'"
            [class.active]="activeTab === 'stories'"
            (click)="setActiveTab('stories')"
          >
            Stories
          </button>
        </div>

        <div
          class="knowledge-hub-tabs--panel"
          role="tabpanel"
          [attr.aria-label]="activeTab === 'resources' ? 'Resources' : 'Stories'"
        >
          <div class="knowledge-hub-resources" *ngIf="activeTab === 'resources'">
            <a
              *ngFor="let resource of resources; trackBy: trackByResourceId"
              class="knowledge-hub-resource-card"
              [href]="resource.downloadUrl"
              [attr.download]="resource.fileName"
            >
              <div class="knowledge-hub-resource-card--content">
                <p class="knowledge-hub-resource-card--title">{{ resource.title }}</p>
                <p class="knowledge-hub-resource-card--description">{{ resource.description }}</p>
                <p class="knowledge-hub-resource-card--meta">{{ resource.fileName }}</p>
              </div>
              <span class="knowledge-hub-resource-card--action">Download</span>
            </a>
          </div>

          <div class="knowledge-hub-empty" role="status" *ngIf="activeTab === 'stories'">
            <p class="knowledge-hub-empty--title">Coming soon</p>
            <p class="knowledge-hub-empty--text">{{ emptyStateHint }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
